import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { removeFromFilter, updateFilter } from "../../store/slices/filterSlice";

const Lab = () => {
  const labRange = [
    { label: "IGI", value: "IGI" },
    { label: "GIA", value: "GIA" },
    { label: "GCAL", value: "GCAL" },
    { label: "IL", value: "INDEPENDENT LABORATORIES" },
  ];
  const dispatch = useDispatch();
  const filterSelect = useSelector((state) => state?.filter);
  const handleAddFilter = (value) => {
    dispatch(updateFilter({ key: "lab", value: value }));
  };
  const handleRemoveFilter = (value) => {
    dispatch(removeFromFilter({ key: "lab", value: value }));
  };
  return (
    <div className="w-100">
      <label className="filter-main-label">Lab</label>
      <div className="filter-bg-container lab-range range-outer-container">
        {labRange.map((item) => {
          return (
            <div
              className={`range-item ${
                filterSelect?.lab?.includes(item?.value) ? "active" : ""
              }`}
              onClick={() =>
                filterSelect?.lab?.includes(item?.value)
                  ? handleRemoveFilter(item?.value)
                  : handleAddFilter(item?.value)
              }
            >
              {item?.label}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Lab;
